import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types/RootState';
import { initialState } from './types';

const selectDomain = (state: RootState) => state.cases || initialState;

export const selectCases = createSelector(selectDomain, state => state.cases);
export const selectSelectedCase = createSelector(selectDomain, state => state.selectedCase);
export const selectCasesLoading = createSelector(selectDomain, state => state.loading);
export const selectCaseDetailLoading = createSelector(selectDomain, state => state.detailLoading);
export const selectCasesServiceFailure = createSelector(selectDomain, state => state.serviceFailure);
